import React from 'react'
import { StyledFinanceDisclaimerText, StyledLink, StyledSeparator } from './finance-disclaimer-text.style'
import { Link } from '@at/design-system-elements'
import { useForm } from '../../hocs/form.context'

export const FinanceDisclaimerText = () => {
    const { finance } = useForm()
    return (
        <StyledFinanceDisclaimerText as="p">
            {'Finance examples for '}
            <Link href={finance?.hpGuideLink} target="_blank" title="Buying a car using Hire Purchase (HP)">
                <StyledLink>HP</StyledLink>
            </Link>
            <StyledSeparator>,</StyledSeparator>
            <Link
                href={finance?.hpGuideLink}
                target="_blank"
                title="Buying a car using Hire Purchase Conditional Sale (HP)"
            >
                <StyledLink>CS</StyledLink>
            </Link>
            <StyledSeparator>,</StyledSeparator>
            <Link href={finance?.pcpGuideLink} target="_blank" title="Buying a car using Personal Contract Plan (PCP)">
                <StyledLink>PCP</StyledLink>
            </Link>
            {' will be returned if available, based on the above parameters. Finance subject to status.'}
        </StyledFinanceDisclaimerText>
    )
}
